/**
 * Amasty Multiple Wishlist compatibility for ScandiPWA
 * @copyright Scandiweb, Inc. All rights reserved.
 */

export const PRODUCT_PAGE_POPUP_ID = 'productPage';
export const WISHLIST_COPY = 'wishlistscopy';
export const WISHLIST_MOVE = 'wishlistsmove';
export const WISHLIST_ADD = 'wishlistsadd';
export const WISHLIST_OPERATION_COPY = 'copy';
export const WISHLIST_OPERATION_MOVE = 'move';
export const WISHLIST_OPERATION_STEADY = 'steady';
export const WISHLIST_OPERATION_EDIT = 'edit';
export const WISHLIST_ITEMS = 'WishlistItems';
